import type { RootState } from 'features/app/store/store';

export const deafPhoneNumberIsHiddenSelector = ({
  deafPhoneNumberHidden,
}: RootState) => deafPhoneNumberHidden.isHidden;
